import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class InternalUser {
    HttpAdapter = new HttpAdapter();
    baseUrlInternalUsers = `${publicSettings.aws.baseUrls.usersManagement}/users/internal`;

    constructor() {}

    async getAll() {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlInternalUsers}/get-all`,
                {}
            );
            return response.list;
        } catch (error) {
            console.error("Erro ao buscar usuários:", error);
            return [];
        }
    }

    async getByIds(ids) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlInternalUsers}/get-by-ids`,
                { ids }
            );
            return response.list;
        } catch (error) {
            console.error("Erro ao buscar usuários:", error);
            return [];
        }
    }

    async saveMany(users) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlInternalUsers}/save-many`,
                { users }
            );

            if (response && response.list) {
                return response.list;
            } else if (response) {
                return response;
            } else {
                console.error("Resposta vazia do saveMany");
                return [];
            }
        } catch (error) {
            console.error("Erro ao salvar usuários:", error);
            return [];
        }
    }

    async removeUser(id) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlInternalUsers}/remove-by-ids`,
            { _id: id }
        );
        return response;
    }

    async updatePassword(id, password) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlInternalUsers}/save-many`,
                { users: [{ _id: id, password: password }] }
            );

            if (response && response.list) {
                return response.list;
            } else if (response) {
                return response;
            } else {
                console.error("Resposta vazia do updatePassword");
                return [];
            }
        } catch (error) {
            console.error("Erro ao atualizar senha do usuário:", error);
            return [];
        }
    }
}
